import { Outlet } from "@remix-run/react";
import { LoaderFunctionArgs, redirect } from "@remix-run/node";
import { getAllowedCompany } from "~/utils/config/allowedCompany";

export const loader = async ({ params, request }: LoaderFunctionArgs) => {
  const company = getAllowedCompany(params.company);

  if (params.company === company) {
    return null;
  }

  const url = new URL(request.url);
  const suffix = url.pathname.split("/").slice(2).join("/");
  const normalizedPath = `/${company}/${suffix}`;

  throw redirect(`${normalizedPath}${url.search}`);
};

export default function AppLayout() {
  return <Outlet />;
}
